<template>
    <div class="h_c_link">
        <div class="h_c_link_content">
            <p class="h_c_link_c_title">
                友情链接
            </p>
            <ul class="h_c_link_c_a">
                <li>
                    <a target="_blank" href="http://www.zjepb.gov.cn/">
                        <img src="../../assets/images/link1.png" alt="">
                    </a>
                </li>
                <li>
                    <a target="_blank" href="http://jhyw.zjzwfw.gov.cn/">
                        <img src="../../assets/images/link2.png" alt="">
                    </a>
                </li>
                <li>
                    <a target="_blank" href="http://www.ywhbw.com/">
                        <img src="../../assets/images/link3.png" alt="">
                    </a>
                </li>
                <li>
                    <a target="_blank" href="http://www.pj.gov.cn/">
                        <img src="../../assets/images/link4.png" alt="">
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "friendLink"
    }
</script>

<style scoped>
    /*友情链接*/
    .h_c_link{
        width: 100%;
        height: 200px;
        background: url("../../assets/images/linkbg.png") no-repeat center/1920px 200px;
    }
    .h_c_link .h_c_link_content{
        width: 1100px;
        margin: 0 auto;
    }
    .h_c_link_content .h_c_link_c_title{
        padding: 40px 0 30px;
        color: #fff;
        font-size: 30px;
        text-align: center;
        letter-spacing: 4px;
    }
    .h_c_link_content .h_c_link_c_a{
        display: flex;
        justify-content: space-between;
    }
    .h_c_link_content .h_c_link_c_a li{
        width: 192px;
        height: 46px;
    }
    .h_c_link_content .h_c_link_c_a li img{
        display: block;
        width: 192px;
        height: 46px;
    }
</style>